export default __webpack_public_path__ + "static/media/brand_bg01.a9a6c31a.png";